import(/* webpackMode: "eager", webpackExports: ["CategoryPageClient"] */ "/home/runner/work/baysgaia-site/baysgaia-site/src/components/templates/CategoryPageClient/CategoryPageClient.tsx");
